"use strict";

var _interopRequireDefault = require("C:/Users/sandy/Desktop/EIOSYS/Admin/Alembic-Grow-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rejectRedemption = exports.getRedemptions = exports.defaultRedemptionData = exports.approveRedemption = void 0;
var _request = _interopRequireDefault(require("@/utils/request"));
const defaultRedemptionData = exports.defaultRedemptionData = {
  id: 0,
  status: '',
  employeeId: undefined,
  prizeId: undefined,
  prize: undefined,
  employee: undefined
};
const getRedemptions = params => (0, _request.default)({
  url: '/redemptions',
  method: 'get',
  params
});
exports.getRedemptions = getRedemptions;
const approveRedemption = data => (0, _request.default)({
  url: '/redemptions/approve',
  method: 'post',
  data
});
exports.approveRedemption = approveRedemption;
const rejectRedemption = data => (0, _request.default)({
  url: '/redemptions/reject',
  method: 'post',
  data
});
exports.rejectRedemption = rejectRedemption;